<template>
  <div v-if="shopAccess" class="city">
    <button type="button" class="city__button" @click="open">
      <el-icon><LocationInformation /></el-icon>
      <span class="city__name">{{ city ? city.city : "Выбрать город" }}</span>
    </button>

    <el-dialog
      v-model="visible"
      title="Ваш населённый пункт"
      width="460px"
      append-to-body
      :close-on-click-modal="true"
    >
      <p class="city__hint">
        От города зависят стоимость и срок доставки. Начните вводить название —
        список берётся из справочника СДЭК.
      </p>

      <!-- Обёртка нужна: у el-autocomplete несколько корневых узлов,
           и scoped-стили на сам компонент не навешиваются -->
      <div class="city__field">
        <el-autocomplete
          v-model="query"
          :fetch-suggestions="fetchCities"
          :trigger-on-focus="false"
          :debounce="300"
          value-key="full_name"
          placeholder="Например, Казань"
          clearable
          style="width: 100%"
          @select="onSelect"
        />
      </div>

      <div v-if="detecting" class="city__hint city__hint--busy">Определяем город…</div>

      <template #footer>
        <el-button v-if="city" @click="reset">Сбросить</el-button>
        <el-button type="primary" @click="visible = false">Готово</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { LocationInformation } from "@element-plus/icons-vue";

const shopAccess = useShopAccess();
const { city, detecting, setCity, search, ensure } = useCity();

const visible = ref(false);
const query = ref("");

// Восстанавливаем сохранённый выбор, а если его нет — пробуем определить
// по IP. И то и другое возможно только на клиенте, поэтому в onMounted
onMounted(async () => {
  await ensure();
  query.value = city.value?.full_name ?? "";
});

const open = () => {
  query.value = city.value?.full_name ?? "";
  visible.value = true;
};

const fetchCities = async (value, cb) => {
  cb(await search(value));
};

const onSelect = (item) => {
  setCity(item);
  query.value = item.full_name;
  visible.value = false;
};

const reset = () => {
  setCity(null);
  query.value = "";
};
</script>

<style scoped>
.city {
  display: flex;
  align-items: center;
}

.city__button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 190px;
  padding: 2px 4px;
  border: 0;
  background: none;
  font: inherit;
  font-size: 13px;
  color: var(--el-text-color-regular);
  cursor: pointer;
  white-space: nowrap;
}

.city__button:hover {
  color: var(--el-color-primary);
}

.city__name {
  overflow: hidden;
  text-overflow: ellipsis;
  /* Пунктир — привычный признак того, что значение можно сменить */
  border-bottom: 1px dashed currentColor;
}

.city__hint {
  margin: 0 0 12px;
  font-size: 13px;
  color: var(--el-text-color-regular);
  line-height: 1.45;
}

.city__hint--busy {
  margin: 8px 0 0;
  color: var(--el-text-color-secondary);
}

.city__field {
  width: 100%;
}
</style>
